import SortAction from "./SortAction.js";
import AttributeSortModel from "./AttributeSortModel.js";
import AttributeSortModelEditor from "./AttributeSortModelEditor.js";
export default {
  install(molten) {
    molten.addPlugin('Action', SortAction);
    molten.addPlugin('ModelEditor', {
      type: AttributeSortModel.TYPE,
      editor: AttributeSortModelEditor
    });
  }
};